module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADgSURBVHgBjVOBEcIgDAwuIE4gI3QFJ1AnsJu0o7iBbuAI6gTVCXAD/G9BKZdqc/dHIf8BvkGkiBBCDVwAH4bwcX4ouSYTOQwn4AWcIxgroAKaON8YYx75bg7ogEZ+BPOR5/LFv8KiwDW/Y6eQKpI4KrnegwW+aUQ7sRGFS2WdftQS3dSqu+j2eiLnubMFvFKdrgucfYoedpFIZUDE9eOUkDqKb8BOOxpJGK0irnpd6ihFbKPbTsl1n46LpFZmBHmjX5t1WDtHmE5T9nY6Povc5WvmVgZfeP/9qLeL6rNf1RteoeUwcMuCXwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certification2.png
// module id = Nlwj
// module chunks = 1